export function joinPaths(...paths: string[]): string {
  return paths
    .map((path) => path.replace(/(^\/+|\/+$)/g, ""))
    .filter(Boolean)
    .join("/");
}

export function normalizePath(path: string) {
  return `/${path.replace(/^\//, "")}`.replace(/\/+/g, "/");
}

/**
 * Obtém o valor de um cookie pelo nome
 * @param name - O nome do cookie a ser recuperado
 * @returns O valor do cookie ou undefined se não encontrado
 * @note: cookies httpOnly true não são acessíveis via JavaScript
 */
export function getCookie(name: string): string | undefined {
  const cookies = document.cookie.split(";");

  for (const cookie of cookies) {
    const [cookieName, cookieValue] = cookie.trim().split("=");
    if (cookieName === name) {
      return cookieValue;
    }
  }

  return undefined;
}
